import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Spin } from "@arco-design/web-react";
import { clearLocalToken } from "./Api/localAuth";

// /logout — the user menu's "Log out". Ends the session immediately instead of
// rendering a second "Log Out" button. Clears the dev local-auth token too, which
// the old Auth0-only logout left behind (so local users never logged out).
const LogoutButton = () => {
  const { logout, isAuthenticated, isLoading } = useAuth0();

  React.useEffect(() => {
    clearLocalToken();
    if (!isLoading && isAuthenticated) {
      logout({ returnTo: window.location.origin + "/login" });
    }
  }, [isLoading, isAuthenticated, logout]);

  if (!isLoading && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Spin style={{ display: "block", margin: "80px auto" }} />;
};

export default LogoutButton;
